import React, { Fragment } from 'react';
const Loading = () => {
    function renderDivs() {
        let array = [];
        for (let i = 0; i < 12; i++) {
            array.push(
                <div key={i}></div>
            );
        }
        return array
    }
    function renderLoader() {

        return (
            <div style={{
                height: "100vh",
                width: "100vw",
                display: 'flex',
                alignSelf: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}>
                <div className='lds-spinner' style={{ transform: "translate(-50%,-50%)" }}>
                    {renderDivs()}
                </div>
            </div>
        )
    }
    return (
        <Fragment>
            {renderLoader()}
        </Fragment>
    );
}


export default Loading;


// WEBPACK FOOTER //
// ./src/components/common/Loading/index.jsx